export default __webpack_public_path__ + "static/media/linkedin-icon-hover-state.f87a409a.svg";